import { render, staticRenderFns } from "./BuildingSocietyAttachments.vue?vue&type=template&id=17fa158a&scoped=true&"
import script from "./BuildingSocietyAttachments.vue?vue&type=script&lang=js&"
export * from "./BuildingSocietyAttachments.vue?vue&type=script&lang=js&"
import style0 from "./BuildingSocietyAttachments.vue?vue&type=style&index=0&id=17fa158a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fa158a",
  null
  
)

export default component.exports